// src/pages/AdminPage.tsx
import React from 'react';
//import { useNavigate } from 'react-router-dom';
//import { AdminOnly } from '../auth/AdminOnly';
import { useAuth } from '../auth/AuthProvider';


const AdminPage: React.FC = () => {
    const { user, logout } = useAuth();
  return (
    <div>
        
        {user?.role === 'admin' ? (
        <p>환영합니다 {user.name}님 ({user.role})</p>
        ) : (
        <p>관리자만 접근 가능 </p>
        )}
        {/* <button onClick={logout}>로그아웃</button> */}
    </div>
  );
};

export default AdminPage;
